// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1xJ2S","upload":"Small_upload__1Jc-M","imageWrap":"Small_imageWrap__29yIm","removeBtn":"Small_removeBtn__2bRBH"};